import { render, staticRenderFns } from "./cms-block-builder.vue?vue&type=template&id=438baa7a&scoped=true"
import script from "./cms-block-builder.vue?vue&type=script&lang=js"
export * from "./cms-block-builder.vue?vue&type=script&lang=js"
import style0 from "./cms-block-builder.vue?vue&type=style&index=0&id=438baa7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438baa7a",
  null
  
)

export default component.exports